var $e5efad074a74abef$exports = {};
$e5efad074a74abef$exports = {
    "dropzoneLabel": `\u{B4DC}\u{B86D} \u{C601}\u{C5ED}`,
    "selectPlaceholder": `\u{D56D}\u{BAA9} \u{C120}\u{D0DD}`,
    "tableResizer": `\u{D06C}\u{AE30} \u{C870}\u{C815}\u{AE30}`
};


export {$e5efad074a74abef$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
